import type { LoadingButtonProps } from '@mui/lab/LoadingButton';
import type { Theme } from '@mui/material/styles';

import { loadingButtonClasses } from '@mui/lab/LoadingButton';

// ----------------------------------------------------------------------

export function loadingButton(_theme: Theme) {
  return {
    MuiLoadingButton: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: LoadingButtonProps }) => ({
          ...(ownerState.variant === 'soft' && {
            [`& .${loadingButtonClasses.loadingIndicatorEnd}`]: {
              right: 14,
            },
            [`& .${loadingButtonClasses.loadingIndicatorStart}`]: {
              left: 10,
            },
            ...(ownerState.size === 'small' && {
              [`& .${loadingButtonClasses.loadingIndicatorEnd}`]: {
                right: 10,
              },
              [`& .${loadingButtonClasses.loadingIndicatorStart}`]: {
                left: 10,
              },
            }),
          }),
        }),
      },
    },
  };
}
